import {combineReducers} from "redux";
import result from "./result";
import results from "./results";
import resultV1 from "./resultV1";

const resultReducer = combineReducers({
    result,
    results,
    resultV1
});
export default resultReducer;
